import { Tabs } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const TabPanel = styled(Tabs.Panel, {
  base: {
    backgroundColor: 'transparent',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export const StyledTabsList = styled(Tabs.List, {
  base: {
    gap: 0,
  },
});

export const StyledTab = styled(Tabs.Tab, {
  base: {
    borderColor: 'bg.neutral',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    minWidth: 'auto',
    height: 'auto',
    lineHeight: 1,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    // eslint-disable-next-line curly-quotes/no-straight-quotes
    '&[aria-selected="false"]': {
      justifyContent: 'center',
    },
    md: {
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
      paddingBottom: '400',
    },
    // eslint-disable-next-line curly-quotes/no-straight-quotes
    '&[aria-selected="true"]': {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      justifyContent: 'center',
      md: {
        paddingBottom: '400',
      },
    },
  },
});
